<template>
  <div>
    <template v-for="(comment, index) in comments">
      <app-comment
        class="mt-5"
        :audioSrc="comment.audio_file"
        :download="!!comment.audio_file"
        :body="comment.content"
        :key="'Comment ' + index"
        :downloadKey="'download-' + index + $store.getters['lesson/step']"
      >
        <template #title>
          <span></span>
        </template>
      </app-comment>
      <v-container :key="'container' + index">
        <v-row align="end">
          <span
            v-if="comment.sub_comments.length"
            class="custom-text px-4 py-1 body-2 comment__div shadow"
            style="background-color: white"
            :key="'responsed' + index"
          >
            <div style="background-color: #29284c" class="white--text px-2 py-1 rounded-lg">
              Student's Answer
              <v-icon right color="white"> mdi-arrow-down-bold </v-icon>
            </div>
          </span>
          <slot v-if="!index" name="reassign" />
          <v-spacer />
          <v-btn
            v-if="$store.getters.profile.role === 'TEACHER'"
            :icon="$vuetify.breakpoint.xs"
            :key="'button' + index"
            class="comment__div mt-4 custom-text"
            @click="onDeleteComment(index)"
            style="background-color: white"
          >
            <span v-if="!$vuetify.breakpoint.xs" class="mr-2 custom-text text-capitalize"
              >Remove Teacher's note</span
            >
            <v-icon color="#29284c">mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <slot name="reassign-tasks" />
      </v-container>
      <app-comment
        v-for="(child, row) in comment.sub_comments"
        :key="'Comment-child ' + row + '-' + index"
        class="mt-3"
        :audioSrc="responses[child].audio_file"
        :download="!!responses[child].audio_file"
        :body="responses[child].content"
        :src="student.avatar"
        :downloadKey="'download-child-' + row + $store.getters['lesson/step']"
      >
        <template #title>
          <span></span>
        </template>
      </app-comment>
      <template v-if="divider">
        <v-divider v-if="index < comments.length - 1" class="my-10" :key="'Divider ' + index" />
      </template>
    </template>
    <v-row justify="center" v-if="$store.getters.profile.role.toLowerCase() === 'teacher'">
      <v-btn
        v-if="$store.getters.profile.role === 'TEACHER' && !(onlyOne && !!comments.length)"
        text
        color="#29284c"
        height="80"
        width="320"
        class="comment__div text-capitalize"
        @click="newComment"
      >
        <v-icon>mdi-plus</v-icon>Add New Teacher's note
      </v-btn>
    </v-row>
    <app-confirm-dialog v-model="confirmDialog" @yes="onYes" :loading="loading"
      >Confirm to delete Teacher's note?</app-confirm-dialog
    >
    <app-feedback-form v-model="dialog" @new-comment="onNewComment" />
  </div>
</template>
<script>
import Comment from "./Comment.vue";
import FeedbackForm from "./FeedbackForm.vue";
import { fetchCommentGroup, postComment, deleteComment } from "@/api/api";
import ConfirmDialog from "../../../ConfirmDialog.vue";
import studentMixin from "@/mixins/studentMixin";

export default {
  components: {
    appComment: Comment,
    appFeedbackForm: FeedbackForm,
    appConfirmDialog: ConfirmDialog,
  },
  props: {
    divider: {
      required: false,
      default: false,
      type: Boolean,
    },
    uuid: {
      required: true,
    },
    onlyOne: Boolean,
  },
  mixins: [studentMixin],
  data() {
    return {
      dialog: false,
      confirmDialog: false,
      comments: [],
      loading: false,
      answerItem: null,
      responses: {},
    };
  },
  computed: {
    profile() {
      return this.$store.getters["profile"];
    },
  },
  methods: {
    onAnswerComment(comment) {
      this.answerItem = comment;
      this.dialog = true;
    },
    async onYes() {
      this.loading = true;
      const response = await deleteComment(this.comments[this.deletedIndex].uuid);
      if (response) {
        this.comments.splice(this.deletedIndex, 1);
      }
      this.loading = false;
      this.confirmDialog = false;
    },
    onDeleteComment(index) {
      this.deletedIndex = index;
      this.confirmDialog = true;
    },
    newComment() {
      this.dialog = true;
    },
    async onNewComment(e) {
      let body = {
        title: e.title,
        content: JSON.stringify(e.text),
        audio_file: e.audioBlob,
        teacher: this.$store.getters.profile.email,
        student: this.student.email,
        comment_group: this.uuid,
      };
      if (this.answerItem) {
        body.parent = this.answerItem.uuid;
        body.notified = true;
      }
      if (this.$route.name === "guided-lesson") {
        body.notified = true;
      }
      this.answerItem = null;
      const response = await postComment(body);
      response.data.content = JSON.parse(response.data.content);
      if (response.data.parent) {
        const item = this.comments.find((comment) => comment.uuid === response.data.parent);
        if (item) {
          this.responses[response.data.uuid] = response.data;
          item.sub_comments.push(response.data.uuid);
        }
      } else this.comments.push(response.data);
    },
    async updateComments(uuid) {
      let params = {
        comment_group__uuid: uuid,
        limit: 20,
      };

      if (this.$store.getters.profile.role === "TEACHER") {
        params.student__email = this.$store.getters.student.email;
      } else if (this.$store.getters.profile.role === "STUDENT") {
        params.student__email = this.$store.getters.profile.email;
      }

      const response = await fetchCommentGroup(params);
      this.comments = [];
      response.data.results.forEach((element) => {
        element.content = JSON.parse(element.content);
        if (!element.parent) {
          this.comments.push(element);
        } else {
          this.responses[element.uuid] = element;
        }
      });
    },
  },
  mounted() {
    if (this.uuid) {
      this.updateComments(this.uuid);
    }
  },
  watch: {
    uuid(value) {
      if (value) {
        this.updateComments(value);
      }
    },
    dialog(value) {
      this.$emit("comment-dialog", value);
    },
  },
};
</script>
<style scoped>
.comment__div {
  border: dashed #29284c 2px;
  border-radius: 10px;
}
</style>
